export default __webpack_public_path__ + "static/media/real-time.c5601a82.svg";